module.exports = __webpack_public_path__ + "img/DOP.2a1e1e31.svg";